// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-content {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 20px;
    align-items: flex-start;
}

#main-content h2 {
    font-size: 20px;
    color: white;
    padding: 0;
    margin: 0;
}

.panel {
    background-color: white;
    min-height: 500px;
    border-radius: 25px;
    overflow: hidden;
}

.panel-header {
    padding: 20px;
}

.panel-header-x-out {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.panel-content {
    max-height: 100vh !important;
    overflow-y: auto;
}

#classes-panel {
    min-width: 250px;
}

#classes-panel-header {
    background-color: var(--dark-purple);
}

.class-option {
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.class-option:hover {
    background-color: #EEEEEE;
    cursor: pointer;
}

.selected-class {
    background-color: #ECE0F0;
}

.selected-class:hover {
    background-color: #E5CBEE;
}

#students-panel {
    width: 100%;
    max-height: 100%;
}

#students-panel-header {
    background-color: var(--light-purple);
}

#students-panel .panel-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
}

#artwork-magnifier {
    position: fixed;
    top: 25%;
    left: 25%;
    height: 50vh;
    max-width: 50vw;
    background-color: white;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}

#artwork-magnifier, #artwork-magnifier .panel-header {
    border-radius: 15px;
}

#artwork-magnifier .panel-header {
    background-color: var(--light-purple);
    color: white;
}

#magnifier-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
}

#artwork-content {
    padding: 15px;
    display: flex;
    flex-direction: row;
    gap: 25px;
    /* flex-grow: 1; */
    overflow-y: auto;
}

#artwork {
    max-height: 80%;
    max-width: 60%;
}

#about-and-options {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

#artist-info {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
}

#artist-info h3 {
    font-size: 24px;
    padding: 0;
    margin: 0;
}

#delete-button {
    background-color: #B60000;
    color: white;
    border-style: none;
    border-radius: 10px;
    padding: 5px;
}

#trash-can {
    height: 30px;
}

#confirm-deletion {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
}

#confirm-deletion > div {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
}

#confirm-deletion-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding: 10px;
}

#confirm-deletion-buttons > button {
    flex-grow: 1;
}

.student {
    padding: 20px;
    background-color: #E4FBFF;
    border-style: solid;
    border-color: var(--blue);
    border-radius: 10px;
}

#student-header {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
}

#student-header p {
    padding: 0;
    margin: 0;
}

#student-name {
    font-weight: bold;
}

#student-email {
    color: #555555;
}

.gallery {
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: nowrap;
    overflow-y: auto;
}

.gallery img {
    height: 100px;
}

.gallery img:hover {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/ClassesPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["#main-content {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    padding: 20px;\n    align-items: flex-start;\n}\n\n#main-content h2 {\n    font-size: 20px;\n    color: white;\n    padding: 0;\n    margin: 0;\n}\n\n.panel {\n    background-color: white;\n    min-height: 500px;\n    border-radius: 25px;\n    overflow: hidden;\n}\n\n.panel-header {\n    padding: 20px;\n}\n\n.panel-header-x-out {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.panel-content {\n    max-height: 100vh !important;\n    overflow-y: auto;\n}\n\n#classes-panel {\n    min-width: 250px;\n}\n\n#classes-panel-header {\n    background-color: var(--dark-purple);\n}\n\n.class-option {\n    padding: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.class-option:hover {\n    background-color: #EEEEEE;\n    cursor: pointer;\n}\n\n.selected-class {\n    background-color: #ECE0F0;\n}\n\n.selected-class:hover {\n    background-color: #E5CBEE;\n}\n\n#students-panel {\n    width: 100%;\n    max-height: 100%;\n}\n\n#students-panel-header {\n    background-color: var(--light-purple);\n}\n\n#students-panel .panel-content {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n}\n\n#artwork-magnifier {\n    position: fixed;\n    top: 25%;\n    left: 25%;\n    height: 50vh;\n    max-width: 50vw;\n    background-color: white;\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n}\n\n#artwork-magnifier, #artwork-magnifier .panel-header {\n    border-radius: 15px;\n}\n\n#artwork-magnifier .panel-header {\n    background-color: var(--light-purple);\n    color: white;\n}\n\n#magnifier-panel {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n#artwork-content {\n    padding: 15px;\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    /* flex-grow: 1; */\n    overflow-y: auto;\n}\n\n#artwork {\n    max-height: 80%;\n    max-width: 60%;\n}\n\n#about-and-options {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n#artist-info {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n#artist-info h3 {\n    font-size: 24px;\n    padding: 0;\n    margin: 0;\n}\n\n#delete-button {\n    background-color: #B60000;\n    color: white;\n    border-style: none;\n    border-radius: 10px;\n    padding: 5px;\n}\n\n#trash-can {\n    height: 30px;\n}\n\n#confirm-deletion {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#confirm-deletion > div {\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n}\n\n#confirm-deletion-buttons {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    padding: 10px;\n}\n\n#confirm-deletion-buttons > button {\n    flex-grow: 1;\n}\n\n.student {\n    padding: 20px;\n    background-color: #E4FBFF;\n    border-style: solid;\n    border-color: var(--blue);\n    border-radius: 10px;\n}\n\n#student-header {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n#student-header p {\n    padding: 0;\n    margin: 0;\n}\n\n#student-name {\n    font-weight: bold;\n}\n\n#student-email {\n    color: #555555;\n}\n\n.gallery {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    flex-wrap: nowrap;\n    overflow-y: auto;\n}\n\n.gallery img {\n    height: 100px;\n}\n\n.gallery img:hover {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
